export const cutExtentionInURL = (url) => {
    const urlObject = new URL(url);
    const pathWithoutExtension = urlObject.pathname.replace(/\.[^/.]+$/, "");
    return urlObject.origin + pathWithoutExtension + urlObject.search + urlObject.hash;
}